
const PayCourse = () => {
    return (
        <>
        Por aca payform
        </>
    );
}

export default PayCourse;